import type { Extension } from '../../../web-client';

/**
 * Returns the installation context ARIs (primary + secondary) of an extension, i.e. the same
 * list exposed to apps as `installation.contexts[].ari` in `view.getContext()`.
 */
export const getInstallationContextAris = (extension: Extension): string[] => {
	const primary =
		extension.installationContext ?? extension.installation?.primaryInstallationContext;
	const secondary =
		extension.secondaryInstallationContexts ??
		extension.installation?.secondaryInstallationContexts ??
		[];

	return primary ? [primary, ...secondary] : [...secondary];
};
